import { Grid, Paper } from '@mui/material';
import ProcessTable from '../ProcessTable';
import KpiPreviewDashboard from '../../../../kpiHub/components/KpiPreviewDashboard';
import TextBox from './TextBox';
import TextArea from './TextArea';
import ImageBox from './ImageBox';
import ActionItem from './ActionItem';
import ShortcutItem from './ShortcutItem';
import ShortcutBar from './ShortcutBar';
import TaskBox from './TaskBox';
import FolderItem from './FolderItem';

export default function DashboardItem({ item, editable, onChange, onDelete, onSave, portalSpaceId, forPortal }) {
  return (
    <Grid
      container
      component={Paper}
      variant="outlined"
      style={{ borderRadius: 5, cursor: editable ? 'grab' : undefined, overflow: 'hidden', height: '100%' }}
    >
      {item.type === 'kpi' && (
        <KpiPreviewDashboard
          download={!editable}
          kpi={item.data}
          onDelete={editable ? () => onDelete(item.id) : null}
          clickable={!editable}
        />
      )}
      {item.type === 'text' && (
        <TextBox
          editable={editable}
          onEdit={(data) => onSave(data)}
          initial={item.data}
          onDelete={() => onDelete(item.id)}
          onChange={(update, layoutUpdate) => onChange(item.id, update, layoutUpdate)}
        />
      )}
      {item.type === 'heading' && (
        <TextArea
          large
          editable={editable}
          onEdit={(data) => onSave(data)}
          initial={item.data}
          onDelete={() => onDelete(item.id)}
          onChange={(update, layoutUpdate) => onChange(item.id, update, layoutUpdate)}
        />
      )}
      {item.type === 'image' && (
        <ImageBox
          editable={editable}
          onEdit={(data) => onSave(data)}
          initial={item.data}
          onDelete={() => onDelete(item.id)}
        />
      )}
      {item.type === 'action' && (
        <ActionItem
          editable={editable}
          item={item.data}
          onDelete={() => onDelete(item.id)}
          onChange={(update, layoutUpdate) => onChange(item.id, update, layoutUpdate)}
          portalSpaceId={portalSpaceId}
        />
      )}
      {item.type === 'shortcut' && (
        <ShortcutItem
          editable={editable}
          item={item.data}
          onDelete={() => onDelete(item.id)}
          onChange={(update) => onChange(item.id, update)}
          portalSpaceId={portalSpaceId}
        />
      )}

      {item.type === 'shortcutBar' && (
        <ShortcutBar
          editable={editable}
          data={item.data}
          onDelete={() => onDelete(item.id)}
          onEdit={(data) => onSave(data)}
          forPortal={forPortal}
          portalSpaceId={portalSpaceId}
        />
      )}
      {item.type === 'taskBox' && (
        <TaskBox
          editable={editable}
          onDelete={() => onDelete(item.id)}
          params={item.data}
          onEdit={(data) => onSave(data)}
          onChange={(update) => onChange(item.id, update)}
        />
      )}
      {item.type === 'processTable' && (
        <ProcessTable
          processId={item.processId || item.data}
          editable={editable}
          onDelete={() => onDelete(item.id)}
          view={item.view}
          hideTitle={item.hideTitle}
          hideCompleted={item.hideCompleted}
          selectedStepId={item.selectedStepId}
          onEdit={(data) => onSave(data)}
          initialColor={item.color}
          initialTitle={item.title}
        />
      )}
      {item.type === 'dlfolder' && (
        <FolderItem
          data={item.data}
          onEdit={(data) => onSave(data)}
          editable={editable}
          onDelete={() => onDelete(item.id)}
          onChange={(update) => onChange(item.id, update)}
        />
      )}
    </Grid>
  );
}
